import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';
import { BannerButtonComponent } from '../components/banner/banner-button/banner-button.component';
import { BannerComponent } from '../components/banner/banner.component';
import { BodyComponent } from '../components/body/body.component';
import { ContextStripNavButtonComponent } from '../components/context-strip/context-strip-nav-button/context-strip-nav-button.component';
import { ContextStripComponent } from '../components/context-strip/context-strip.component';
import { FooterComponent } from '../components/footer/footer.component';
import { HeaderNavComponent } from '../components/header/header-nav-item/header-nav-item.component';
import { HeaderComponent } from '../components/header/header.component';
import { NavCardComponent } from '../components/nav-card/nav-card.component';
import { InformationDialogComponent } from '../modals/information-dialog/information-dialog.component';
import { MaterialModule } from '../modules/material.module';

@NgModule({
  declarations: [
    BodyComponent,
    ContextStripComponent,
    HeaderComponent,
    BannerComponent,
    FooterComponent,
    NavCardComponent,
    BannerButtonComponent,
    HeaderNavComponent,
    ContextStripNavButtonComponent,
    InformationDialogComponent
  ],
  imports: [FlexLayoutModule, MaterialModule, RouterModule, FormsModule, HttpClientModule, MatNativeDateModule, ReactiveFormsModule],
  exports: [
    FlexLayoutModule,
    MaterialModule,
    RouterModule,
    HttpClientModule,
    BodyComponent,
    ContextStripComponent,
    HeaderComponent,
    BannerComponent,
    FooterComponent,
    NavCardComponent,
    BannerButtonComponent,
    HeaderNavComponent,
    ContextStripNavButtonComponent,
    InformationDialogComponent,
  ],
  providers: [{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } }],
})
export class RootLayoutModule { }
